import { WaterfallTierTypeEnum } from "gen/model/waterfallTierTypeEnum";

export const TierFieldNames = [
  "hurdle_percentages",
  "catch_up_percentage",
  "carry_partner_percentage",
  "participating_partner_percentage",
] as const;

export type TierFieldName = (typeof TierFieldNames)[number];

export type TierFieldState = "disabled" | "not_applicable";

export const fieldStateForTierType: Record<
  WaterfallTierTypeEnum,
  Partial<Record<TierFieldName, TierFieldState> | undefined>
> = {
  [WaterfallTierTypeEnum.preferred_return]: {
    catch_up_percentage: "not_applicable",
    carry_partner_percentage: "disabled",
  },
  [WaterfallTierTypeEnum.return_of_capital]: {
    hurdle_percentages: "not_applicable",
    catch_up_percentage: "not_applicable",
    carry_partner_percentage: "disabled",
  },
  [WaterfallTierTypeEnum.gp_catch_up]: {
    hurdle_percentages: "not_applicable",
  },
  [WaterfallTierTypeEnum.final_split]: {
    hurdle_percentages: "not_applicable",
    catch_up_percentage: "not_applicable",
  },
};
